import { routes } from '../routes';
import { ajax } from 'rxjs/ajax';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
export const vehicleDetails = (clientConfig) => {
    const { baseUrl, headers } = clientConfig;
    const route = routes(baseUrl).GET_VEHICLE_DETAILS;
    /**
     * Function to fetch the details of the vehicle based on id.
     * @param {string} id of the vehicle.
     * @param {number} duration of the lease in months.
     * @param {boolean} maintenance is true if maintenance is included.
     * @param {number} payment is the initial payment for the lease.
     * @param {number} mileage in thousands for vehicle lease.
     * @param {number[] | null} optionsSelected array of selected option ids.
     * @param {number | null} optionsAdded id of last added option.
     * @param {string | null} configuration pricing type.
     */
    const getVehicleDetails = (id, duration, maintenance, payment, mileage, optionsSelected, optionsAdded, configuration) => ajax
        .get(route(id, duration, maintenance, payment, mileage, optionsSelected, optionsAdded, configuration), headers)
        .pipe(map((r) => r.response), catchError((error) => {
        return of(error);
    }));
    return { getVehicleDetails };
};
